import React, { Fragment, Component } from 'react';
import { Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { every } from 'lodash';
import plural from 'pluralize';
import StartBrewModal from '~/containers/startBrewModal/startBrewModal';
import TransferToBriteTankModal from '~/containers/transferToBriteTankModal/transferToBriteTankModal';
import TransferToUniTankModal from '~/containers/transferToUniTankModal/transferToUniTankModal';
import ConfirmTransferToVesselModal from '~/containers/confirmTransferToVesselModal/confirmTransferToVesselModal';
import ConfirmClarificationModal from '~/containers/confirmClarificationModal/confirmClarificationModal';
import ConfirmDryHopModal from '~/containers/confirmDryHopModal/confirmDryHopModal';
import ConfirmLocationModal from '~/containers/confirmLocationModal/confirmLocationModal';

const initialState = {
  isOpen: false,
  startBrewModalOpen: false,
  transferToBriteTankModalOpen: false,
  confirmTransferToVesselModalOpen: false,
  confirmClarificationModalOpen: false,
  confirmDryHopModalOpen: false,
  transferToUniTankModalOpen: false,
  confirmLocationModalOpen: false
};

export default class AgendaActions extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  toggleModal = name => {
    this.setState({
      [`${name}Open`]: !this.state[`${name}Open`]
    });
  };

  onActionSuccess = () => {
    this.setState(initialState);
    this.props.refreshList();
  };

  renderStartBrewingLotItem = lots => {
    const allArePending = every(lots, l => l.status === 'PENDING');

    return (
      allArePending && (
        <DropdownItem onClick={() => this.toggleModal('startBrewModal')}>
          Start brewing selected {plural('lot', lots.length)}
        </DropdownItem>
      )
    );
  };

  renderTransferToBriteTankItem = lotTransfers => {
    const allAreBriteTankTransfers = every(
      lotTransfers,
      t => t && t.status === 'PENDING' && t.type === 'TANK' && t.tankType === 'BRITE_TANK'
    );
    return (
      allAreBriteTankTransfers && (
        <DropdownItem onClick={() => this.toggleModal('transferToBriteTankModal')}>Transfer to brite tank</DropdownItem>
      )
    );
  };

  renderTransferToUniTankItem = lotTransfers => {
    const allAreUniTankTransfers = every(
      lotTransfers,
      t => t && t.status === 'PENDING' && t.type === 'TANK' && t.tankType === 'UNI_TANK'
    );
    return (
      allAreUniTankTransfers && (
        <DropdownItem onClick={() => this.toggleModal('transferToUniTankModal')}>Transfer to uni tank</DropdownItem>
      )
    );
  };

  renderConfirmTransferToVesselItem = lotTransfers => {
    const allAreAllVesselTransfers = every(lotTransfers, t => t && t.status === 'PENDING' && t.type === 'VESSEL');
    return (
      allAreAllVesselTransfers && (
        <DropdownItem onClick={() => this.toggleModal('confirmTransferToVesselModal')}>
          Confirm transfer to vessel
        </DropdownItem>
      )
    );
  };

  renderConfirmClarificationItem = lotTransfers => {
    const allAreClarifications = every(lotTransfers, t => t && t.status === 'PENDING' && t.type === 'CLARIFICATION');
    return (
      allAreClarifications && (
        <DropdownItem onClick={() => this.toggleModal('confirmClarificationModal')}>
          Confirm clarification step
        </DropdownItem>
      )
    );
  };

  renderConfirmLocationItem = lotTransfers => {
    const allAreClarifications = every(lotTransfers, t => t && t.status === 'PENDING' && t.type === 'LOCATION');
    return (
      allAreClarifications && (
        <DropdownItem onClick={() => this.toggleModal('confirmLocationModal')}>
          Confirm location transfer step
        </DropdownItem>
      )
    );
  };

  renderConfirmDryHopItem = lotTransfers => {
    const allAreDryHops = every(lotTransfers, t => t && t.status === 'PENDING' && t.type === 'DRY_HOP');
    return (
      allAreDryHops && (
        <DropdownItem onClick={() => this.toggleModal('confirmDryHopModal')}>Confirm dry hopping</DropdownItem>
      )
    );
  };

  render() {
    const { selectedEvents } = this.props;

    if (!selectedEvents || !Object.keys(selectedEvents).length) {
      return <Button disabled>Check items to see actions</Button>;
    }

    const {
      startBrewModalOpen,
      transferToBriteTankModalOpen,
      confirmTransferToVesselModalOpen,
      confirmClarificationModalOpen,
      confirmDryHopModalOpen,
      transferToUniTankModalOpen,
      confirmLocationModalOpen
    } = this.state;
    const lots = [];
    const lotTransfers = [];
    Object.keys(selectedEvents).forEach(k => {
      lots.push(selectedEvents[k].resource.lot || selectedEvents[k].resource.consolidatedLot);
      lotTransfers.push(selectedEvents[k].resource.lotTransfer);
    });

    return (
      <Fragment>
        <ButtonDropdown className="input-height" isOpen={this.state.isOpen} toggle={this.onToggle}>
          <DropdownToggle caret>Actions</DropdownToggle>
          <DropdownMenu>
            <Fragment>
              {this.renderStartBrewingLotItem(lots)}
              {this.renderTransferToBriteTankItem(lotTransfers)}
              {this.renderConfirmTransferToVesselItem(lotTransfers)}
              {this.renderConfirmClarificationItem(lotTransfers)}
              {this.renderConfirmDryHopItem(lotTransfers)}
              {this.renderTransferToUniTankItem(lotTransfers)}
              {this.renderConfirmLocationItem(lotTransfers)}
            </Fragment>
          </DropdownMenu>
        </ButtonDropdown>
        <StartBrewModal
          lots={lots}
          isOpen={startBrewModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('startBrewModal')}
          refetchQueries={['agenda']}
        />
        <TransferToBriteTankModal
          lotTransfers={lotTransfers}
          isOpen={transferToBriteTankModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('transferToBriteTankModal')}
          refetchQueries={['agenda']}
        />
        <TransferToUniTankModal
          lotTransfers={lotTransfers}
          isOpen={transferToUniTankModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('transferToUniTankModal')}
          refetchQueries={['agenda']}
        />
        <ConfirmTransferToVesselModal
          lotTransfers={lotTransfers}
          isOpen={confirmTransferToVesselModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('confirmTransferToVesselModal')}
          refetchQueries={['agenda']}
        />
        <ConfirmClarificationModal
          lotTransfers={lotTransfers}
          isOpen={confirmClarificationModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('confirmClarificationModal')}
          refetchQueries={['agenda']}
        />
        <ConfirmDryHopModal
          lotTransfers={lotTransfers}
          isOpen={confirmDryHopModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('confirmDryHopModal')}
          refetchQueries={['agenda']}
        />
        <ConfirmLocationModal
          lotTransfers={lotTransfers}
          isOpen={confirmLocationModalOpen}
          onSuccess={this.onActionSuccess}
          onToggle={() => this.toggleModal('confirmconfirmLocationModal')}
          refetchQueries={['agenda']}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/agendaActions/agendaActions.jsx